import Badge from '@/src/components/atom/Badge';
import Button from '@/src/components/atom/Button';
import Dialog from '@/src/components/atom/Dialog';
import SectionLabel from '@/src/components/molecule/SectionLabel';
import { BUTTON_CONST } from '@/src/constants/buttons';
import { OPTIONS_CONST } from '@/src/constants/options';
import { RecyclingPackageProductDto } from '@/src/models/RecyclingProductDto';

interface RecyclingPackageProductDetailModalProps {
  open: boolean;
  onOpenChange: (value: boolean) => void;
  onOkClick: () => void;
  data?: RecyclingPackageProductDto;
}

const RecyclingPackageProductDetailModal = ({
  open: openProps,
  onOpenChange: onOpenChangeProps,
  onOkClick,
  data,
}: RecyclingPackageProductDetailModalProps) => {
  const handleCloseModal = () => {
    onOpenChangeProps(false);
  };

  const renderFooter = () => {
    return (
      <div className="flex justify-end gap-2">
        <Button
          className="flex-1"
          buttonColor="outline"
          onClick={handleCloseModal}
        >
          {BUTTON_CONST.cancel}
        </Button>
        <Button className="flex-1" onClick={onOkClick}>
          {BUTTON_CONST.editShort}
        </Button>
      </div>
    );
  };

  return data ? (
    <Dialog
      open={openProps}
      onOpenChange={handleCloseModal}
      contentProps={{
        style: { width: 'calc(100vw - 24px)' },
        className: 'max-w-[697px]',
      }}
      title="수거 기본 품목 상세"
      footer={renderFooter()}
    >
      <div className="flex flex-col gap-6">
        <SectionLabel label="수거 품목명" value={data.name} />
        <SectionLabel label="무게 (g)" value={data.weight} />
        <SectionLabel
          label="탄소 감축량 (g)"
          value={data.carbonEmissionReduction}
        />
        <SectionLabel label="소나무 지수" value={data.pineScore} />
        <SectionLabel label="단위" value={data.unitKr} />
        <SectionLabel label="최대 무게 (g)" value={data.maximumWeight} />
        <SectionLabel
          label="앱 내 적용 여부"
          value={
            <Badge badgeColor={data.isForApp ? 'lightGreen' : 'lightGray'}>
              {data.isForApp ? OPTIONS_CONST.applied : OPTIONS_CONST.notApplied}
            </Badge>
          }
        />
      </div>
    </Dialog>
  ) : null;
};

export default RecyclingPackageProductDetailModal;
